import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-form-field-checkbox-v2',
    templateUrl: './form-field-checkbox-v2.component.html',
    styleUrls: ['./form-field-checkbox-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldCheckboxV2Component {
  @Input() configData;
  @Input() frmGroup: UntypedFormGroup;
  constructor() { }

  handleClick(){
  }

}
